export function RequestLinkPage({ error }: { error?: string | null }) {
  // Error case: show message about requesting new link
  if (error) {
    return (
      <div className="min-h-screen-safe flex items-center justify-center bg-white px-4">
        <div className="max-w-md w-full text-center">
          <h1 className="text-2xl font-semibold text-text-primary mb-4">
            Link Expired
          </h1>
          <p className="text-text-secondary mb-6">
            To get a new link, text Wren:
          </p>
          <p className="text-text-primary font-medium">
            "Hey, Wren! Can you send me a magic link to login?"
          </p>
        </div>
      </div>
    );
  }

  // No token, not authenticated: redirect to marketing site
  window.location.replace("https://chatwren.com");
  return null;
}
